import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'outline' | 'danger' | 'secondary' | 'ghost';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: string;
  children?: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'ts-btn-primary',
  outline: 'ts-btn-outline',
  danger: 'ts-btn-danger',
  secondary: 'ts-btn-outline',
  ghost: 'ts-btn-ghost',
};

export function Button({ variant = 'primary', icon, children, className, ...rest }: Props) {
  return (
    <button {...rest} className={clsx(VARIANT_CLASS[variant], className)}>
      {icon ? <i className={`bi bi-${icon}`} /> : null}
      {children}
    </button>
  );
}
